<template>
  <div class="footer-box">
    <div class="footer-message">
      <p>1、微信进入“常青藤爸爸公众号”，发送“客服”，即可联系人工客服哦～</p>
      <p>
        2、客服热线：
        <a href="tel:4000602636">400-060-2636</a>
      </p>
      <div v-if="!isXcxWeb" class="tc">
        <div class="button-phone">
          <a href="javascript:;">
            <CustomerButton>联系客服</CustomerButton>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store/store'
import { isXcxWeb } from '@ivy/fts/utils'

export default {
  components: {
    CustomerButton: () => import('@ivy/fts/comps/Customer'),
  },
  data() {
    return {
      store,
      userInfo: store.userInfo,
      isXcxWeb: isXcxWeb(),
    }
  },
  created() {},
  methods() {},
}
</script>

<style lang="less">
.footer-box {
  background: white;
  padding: 0px 30px;
  margin-bottom: 12px;
  overflow: hidden;
  margin-bottom: 35px;
  border-radius: 18px;
  .footer-message {
    padding: 24px 0 12px 0;
    position: relative;
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #888888;
    p {
      margin: 12px 0;
      a {
        color: #00b097;
      }
    }
    .tc {
      font-family: PingFangSC-Regular;
      font-size: 26px;
      color: #888888;
      text-align: center;
      margin: 40px 0;
      .button-phone {
        display: inline-block;
        border: 2px solid #00b097;
        border-radius: 100px;
        color: #00b097;
        padding: 10px 30px;
        a {
          color: #00b097;
        }
      }
    }
  }
}
</style>
